<template>
  <b-form-group
    label="Url"
    label-for="url"
  >
    <validation-provider
      #default="{ errors }"
      name="Url"
      rules="required"
    >
      <b-form-input
        id="url"
        v-model="dataItem.url"
        placeholder="Url"
      />
      <small class="text-danger">{{ errors[0] }}</small>
    </validation-provider>
  </b-form-group>
</template>

<script>
import { ValidationProvider, localize } from 'vee-validate'
import {
  BFormGroup, BFormInput,
} from 'bootstrap-vue'
import { required } from '@validations'

export default {
  name: 'ProjectUrl',
  components: {
    BFormGroup,
    BFormInput,
    ValidationProvider,
  },
  data() {
    return {
      required,
    }
  },
  computed: {
    dataItem() {
      return this.$store.getters['projects/dataItem']
    },
  },
  created() {
    localize('tr')
  },
}
</script>
